import { createVanIconComponent } from "./van"

const Clock = createVanIconComponent("clock")
export default Clock
